module Meevo.Plugins.SelfCheckInKioskSettings {
    export enum FiveStarRatingsClientNameFormatEnum {
        FirstNameLastInitial = 11039637,
        FirstInitialLastInitial = 11039638,
        FirstInitialLastName = 11039639,
        FirstNameLastName = 11039640,
        DoNotDisplay = 11039641
    }

    export interface IFiveStarRatingSetting {
        settings: {
            id: number;
            displayName: string;
            effectiveValue: string;
            settableLevels: number;
        }[];
        isSingleLocation: boolean;
        clientNameFormat: number;
        displayRatedEmployee: boolean;
        displayRatedService: boolean;
        sendRatingRequestsEveryX: number;
        automaticallyPublishRatingThreshold: number;
        facebookRecommendationsUrl?: string;
        googleReviewUrl?: string;
        yelpReviewsUrl?: string;
    }
}
